import { ArrowLeft, ArrowRight, ArrowUpRight, Mail, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { contactDetails } from "../data/moselcars";

export default function VehicleModal({ vehicle, onClose }) {
  const images = vehicle.images?.length ? vehicle.images : [vehicle.image];
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const pointerStart = useRef(null);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "ArrowRight") setActiveImageIndex((index) => (index + 1) % images.length);
      if (event.key === "ArrowLeft") setActiveImageIndex((index) => (index - 1 + images.length) % images.length);
    };
    document.addEventListener("keydown", closeOnEscape);
    document.body.classList.add("modal-open");
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.classList.remove("modal-open");
    };
  }, [images.length, onClose]);

  useEffect(() => {
    setActiveImageIndex(0);
  }, [vehicle?.id]);

  if (!vehicle) return null;
  const emailLink = `mailto:${contactDetails.email}?subject=${encodeURIComponent(`Anfrage: ${vehicle.brand} ${vehicle.title}`)}&body=${encodeURIComponent(`Hallo Moselcars, ich interessiere mich für den ${vehicle.brand} ${vehicle.title}.`)}`;
  const showImage = (index) => setActiveImageIndex((index + images.length) % images.length);
  const handlePointerDown = (event) => {
    if (images.length < 2 || event.pointerType === "mouse") return;
    pointerStart.current = event.clientX;
    event.currentTarget.setPointerCapture(event.pointerId);
  };
  const handlePointerUp = (event) => {
    if (pointerStart.current === null) return;
    const distance = event.clientX - pointerStart.current;
    if (Math.abs(distance) > 28) showImage(activeImageIndex + (distance < 0 ? 1 : -1));
    pointerStart.current = null;
    if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="vehicle-modal" role="dialog" aria-modal="true" aria-labelledby="vehicle-modal-title" data-testid="vehicle-detail-modal">
        <button className="modal-close" type="button" aria-label="Details schließen" onClick={onClose} data-testid="vehicle-modal-close-button"><X size={20} strokeWidth={1.5} /></button>
        <div className="modal-gallery" data-testid="vehicle-modal-gallery">
          <div className="modal-image" onPointerDown={handlePointerDown} onPointerUp={handlePointerUp} onPointerCancel={() => { pointerStart.current = null; }}>
            <img className="modal-gallery-image" src={images[activeImageIndex]} alt={`${vehicle.brand} ${vehicle.title}, Ansicht ${activeImageIndex + 1} von ${images.length}`} />
            {images.length > 1 && <div className="modal-gallery-controls"><button type="button" aria-label="Vorherige Fahrzeugansicht" onClick={() => showImage(activeImageIndex - 1)} data-testid="vehicle-modal-image-prev-button"><ArrowLeft size={16} /></button><span aria-live="polite" data-testid="vehicle-modal-image-counter">{activeImageIndex + 1} / {images.length}</span><button type="button" aria-label="Nächste Fahrzeugansicht" onClick={() => showImage(activeImageIndex + 1)} data-testid="vehicle-modal-image-next-button"><ArrowRight size={16} /></button></div>}
          </div>
          {images.length > 1 && <div className="modal-thumbnails" role="list" aria-label="Alle Fahrzeugfotos">{images.map((image, index) => <button className={index === activeImageIndex ? "is-active" : ""} type="button" key={`${image}-${index}`} onClick={() => showImage(index)} aria-label={`Fahrzeugansicht ${index + 1} anzeigen`} aria-current={index === activeImageIndex} data-testid={`vehicle-modal-thumbnail-${index + 1}-button`}><img src={image} alt="" /></button>)}</div>}
        </div>
        <div className="modal-copy">
          <span className="mono-label">{vehicle.brand} · {vehicle.year} · {vehicle.availability}</span>
          <h2 id="vehicle-modal-title">{vehicle.title}</h2>
          <p className="modal-edition">{vehicle.edition}</p>
          <p>{vehicle.condition}. Die Anzeige stammt aus dem aktuellen Händlerbestand von A+B Automobile.</p>
          <div className="modal-spec-grid"><div><span>Leistung</span><strong>{vehicle.power}</strong></div><div><span>Laufleistung</span><strong>{vehicle.mileage}</strong></div><div><span>Kraftstoff</span><strong>{vehicle.fuel}</strong></div><div><span>Getriebe</span><strong>{vehicle.gearbox}</strong></div><div><span>Erstzulassung</span><strong>{vehicle.first_registration}</strong></div><div><span>Preis</span><strong>{vehicle.price}</strong></div></div>
          <div className="modal-actions"><a className="button button-primary" href={emailLink} data-testid="vehicle-modal-email-button"><Mail size={16} /> E-Mail anfragen</a><a className="button button-secondary" href="#kontakt" onClick={onClose} data-testid="vehicle-modal-contact-button">Kontaktformular <ArrowUpRight size={16} /></a></div>
        </div>
      </div>
    </div>
  );
}
